// src/pages/auth/Register.jsx
import { useSearchParams } from "react-router-dom";
import RegisterLogin from "./registerlogin";

function Register() {
  const [searchParams] = useSearchParams();
  // Si la URL tiene ?role=employer, role será "employer", si no, "user".
  const role = searchParams.get("role") || "user";

  return <RegisterLogin role={role} />;
}

export default Register;